<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Agendamento de Tarefas</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataTarefas"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/pabx/agendamento/criar"
              target="_blank"
              @click="handleGoToCadastroAgendamentoTarefa"
            >
              Criar Agendamento de Tarefas
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/agendamento/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton($event, item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="item.default">
              <template v-slot:activator="{ on, attrs }">
                <v-btn disabled @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>

            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Agendamentos: {{ qtdTarefas }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import agendamentoStore from '../_store'
import AgendamentosHttpService from '../_services/AgendamentosHttpService'

export default {
  components: { ListPagination },

  mixins: [pagesHomeMixins],

  data: () => ({
    headers: [
      {
        text: 'Agendamento',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Período',
        value: 'tipo',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        justify: 'center',
        sortable: false,
      },
    ],
    dataTarefas: [],
  }),

  computed: {
    ...mapGetters('agendamentoTarefasHomeModulePABXStore', ['getagendamentos']),

    numberOfPages() {
      return Math.ceil(this.dataTarefas.length / this.itemsPerPage)
    },
    qtdTarefas() {
      return this.dataTarefas.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'agendamentoTarefasHomeModulePABXStore', agendamentoStore)
    await this.listarAgendamentos()
    this.dataTarefas = [...this.getagendamentos]

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('agendamentoTarefasHomeModulePABXStore', ['listarAgendamentos']),

    handleGoToCadastroAgendamentoTarefa(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const handleGoToCadastroAgendamentoTarefa = this.$router.resolve({ name: 'agendamento/criar' })
        window.open(handleGoToCadastroAgendamentoTarefa.href, '_blank')
      } else {
        this.$router.push({ name: 'agendamento/criar' })
      }
    },

    updateItemsPerPage(number) {
      this.itemsPerPage = number
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`agendamento/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`agendamento/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(event, item) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToUpdateAgendamento = this.$router.resolve(`agendamento/atualizar/${item._id}`)
        window.open(goToUpdateAgendamento.href, '_blank')
      } else {
        this.$router.push(`agendamento/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o agendamento "${item.description}"?`)
      if (resultado) {
        try {
          await AgendamentosHttpService.deletetarefa(item._id)
          this.dataTarefas = this.dataTarefas.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
  },
}
</script>
